export enum ServerType {

    PleXop = "pleXop",
    Login = "login",
    Compliance = "compliance",
    TradingDemo = "tradingDemo",
    TradingReal = "tradingReal",
    BackOffice = "backOffice",
    Billing = "billing",
    Chat = "chat",
    Api = "api",
    CES = "ces",
    Sara = "sara"
}
